import React from 'react'

import styled from '@emotion/styled'
import { Color, colors, Theme, useTheme } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { trackUTMAndPromoCode } from 'actions/tracking'
import { checkoutClickContinueToDelivery } from 'actions/trackingKeys'
import { userProspect } from 'actions/user'
import { EmailPasswordForm } from 'routes/Checkout/Components/AboutYou/EmailPasswordForm'
import { ErrorMessage } from 'routes/Checkout/Components/ErrorMessage/ErrorMessage'
import { SectionHeader } from 'routes/Checkout/Components/SectionHeader'
import { CheckoutStepIds } from 'routes/Checkout/checkoutConfig'

import { SecurePaymentBanner } from './SecurePaymentBanner'

type AboutYouProps = {
  onStepChange: (nextStepId: CheckoutStepIds) => void
}

type ThemeProp = {
  citrusTheme: Theme
}

const AboutYouContainer = styled.div(({ citrusTheme }: ThemeProp) => {
  const mackerelColor = '#D2D6D9'
  const BreakpointFromMedium = `@media (min-width: ${citrusTheme.tokens.breakpoints[0]})`

  return {
    borderBottom: `1px solid ${mackerelColor}`,
    borderTop: `1px solid ${mackerelColor}`,
    padding: '1rem 0.75rem 1.5rem',
    paddingBottom: '1rem',
    background: colors[Color.White],

    [BreakpointFromMedium]: {
      border: `1px solid ${mackerelColor}`,
      padding: '1.5rem 1.5rem 2rem',
    },
  }
})

export const AboutYou = ({ onStepChange }: AboutYouProps) => {
  const dispatch = useDispatch()
  const { theme } = useTheme()

  const onSubmit = (email: string, password: string, isEmailMarketingEnabled: boolean) => {
    dispatch({
      type: actionTypes.CHECKOUT_SET_EMAIL,
      email,
    })
    dispatch({ type: actionTypes.CHECKOUT_SET_IS_EMAIL_MARKETING_ENABLED, isEmailMarketingEnabled })
    dispatch(trackUTMAndPromoCode(checkoutClickContinueToDelivery))
    dispatch(userProspect())
    onStepChange(CheckoutStepIds.DELIVERY)
  }

  return (
    <>
      <AboutYouContainer citrusTheme={theme} data-testing="checkoutAboutYouSection">
        <SectionHeader title="Create account" />
        <EmailPasswordForm onSubmit={onSubmit} />
        <ErrorMessage />
      </AboutYouContainer>
      <SecurePaymentBanner />
    </>
  )
}
